import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { IconCheck, IconX } from '@tabler/icons-react'

import * as Yup from 'yup'

import { AbstractForm } from '@/components/forms/formik/AbstractForm'
import { EditButton } from '@/components/buttons/EditButton'
import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'
import { editScorecardConfig } from '@/reducers/qa-copilot/qa-copilot.redux'

import { addDefaultSectionHelper } from '../QACopilot.helpers'

export const QACopilotScorecardName = ({ isOutdatedScorecard }) => {
  const dispatch = useDispatch()
  const { id } = useParams()
  const { scorecardConfig } = useSelector((state) => state.qaCopilot)
  const [editingScorecardName, setEditingScorecardName] = useState(id === 'create')

  const handleSubmit = (values, { setSubmitting }) => {
    setSubmitting(false)

    if (scorecardConfig) {
      dispatch(editScorecardConfig({ ...scorecardConfig, name: values.name }))
    } else {
      dispatch(editScorecardConfig({ name: values.name, sections: [addDefaultSectionHelper()] }))
    }
    setEditingScorecardName(false)
  }

  const handleCancel = () => {
    setEditingScorecardName(false)
  }

  return (
    <div className="qa-copilot-scorecard-name">
      <div>
        {!editingScorecardName ? (
          // tooltip is the only way to read a clipped name
          <InteractiveTooltip interactive content={scorecardConfig?.name} placement="bottom-start">
            <h1>{scorecardConfig?.name}</h1>
          </InteractiveTooltip>
        ) : (
          <AbstractForm
            horizontal
            noLabel
            onSubmit={handleSubmit}
            existingValues={{ name: scorecardConfig?.name || '' }}
            schema={[
              {
                name: 'name',
                type: 'text',
                required: true,
                autoFocus: true,
                autoComplete: 'off',
                placeholder: 'Enter a name for your scorecard',
                customValidators: [
                  Yup.string()
                    .required('QA Scorecard config name is required')
                    .max(500, 'Must be less than five hundred characters'),
                ],
              },
            ]}
            buttonProps={{ square: true }}
            closeButtonProps={{ square: true }}
            buttonLabel={<IconCheck />}
            closeButtonLabel={<IconX />}
            onClose={scorecardConfig?.name && handleCancel}
          />
        )}
        {!editingScorecardName && (
          <EditButton
            disabled={isOutdatedScorecard}
            onEdit={() => setEditingScorecardName(!editingScorecardName)}
          />
        )}
      </div>
    </div>
  )
}
